import LOG from "services/loggingService";

let isOggOpusSupported = false;
let oggOpusSupportPromise = null;

function checkForOggOpusSupport() {
    // If the promise is already existing, return it immediately to avoid duplicate code execution
    if (oggOpusSupportPromise != null) {
        return oggOpusSupportPromise;
    }

    oggOpusSupportPromise = new Promise((resolve) => {
        // Check basic codec support first
        const audio = document.createElement("audio");
        if (
            !audio.canPlayType ||
            audio.canPlayType('audio/ogg; codecs="opus"') !== "probably"
        ) {
            resolve(false);
            return;
        }

        const OGG_SUPPORT_TEST_TIMEOUT = 2000;

        // Behavioral test: Try to decode a silent Ogg Opus blob
        const oggBytes = Uint8Array.from([
            // Minimal Ogg Opus header: very short silent clip
            79, 103, 103, 83, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 153, 158, 46, 162,
            0, 0, 0, 0, 207, 76, 232, 47, 1, 19, 79, 112, 117, 115, 72, 101, 97,
            100, 1, 1, 56, 1, 128, 187, 0, 0, 0, 0, 0, 79, 103, 103, 83, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 153, 158, 46, 162, 1, 0, 0, 0, 88, 211, 167,
            186, 1, 61, 79, 112, 117, 115, 84, 97, 103, 115, 12, 0, 0, 0, 76,
            97, 118, 102, 54, 49, 46, 55, 46, 49, 48, 48, 1, 0, 0, 0, 29, 0, 0,
            0, 101, 110, 99, 111, 100, 101, 114, 61, 76, 97, 118, 99, 54, 49,
            46, 49, 57, 46, 49, 48, 49, 32, 108, 105, 98, 111, 112, 117, 115,
            79, 103, 103, 83, 0, 4, 24, 3, 0, 0, 0, 0, 0, 0, 153, 158, 46, 162,
            2, 0, 0, 0, 183, 75, 32, 240, 1, 7, 8, 11, 230, 59, 35, 171, 96,
        ]);
        const oggBlob = new Blob([oggBytes], { type: "audio/opus" });

        // Test playback
        const testAudio = new Audio();
        testAudio.src = URL.createObjectURL(oggBlob);

        const canplaythroughHandler = () => {
            clearTimeout(timeout);
            cleanup();
            resolve(true);
        };
        testAudio.addEventListener("canplaythrough", canplaythroughHandler);

        const errorHandler = () => {
            clearTimeout(timeout);
            cleanup();
            resolve(false);
        };
        testAudio.addEventListener("error", errorHandler);

        const cleanup = () => {
            URL.revokeObjectURL(testAudio.src);
            testAudio.src = "";
            testAudio.load(); // Reset the audio element
            testAudio.removeEventListener(
                "canplaythrough",
                canplaythroughHandler
            );
            testAudio.removeEventListener("error", errorHandler);
            testAudio.remove();
        };

        const timeout = setTimeout(() => {
            cleanup();
            resolve(false);
        }, OGG_SUPPORT_TEST_TIMEOUT); // 2s fallback

        testAudio.load();
    });
    return oggOpusSupportPromise;
}
const audioUtils = {
    init: () => {
        return checkForOggOpusSupport()
            .then((supported) => {
                isOggOpusSupported = supported;
            })
            .catch((error) => {
                LOG.error("Error checking for ogg opus support", error);
                isOggOpusSupported = false;
            });
    },

    get isOggOpusSupported() {
        return isOggOpusSupported;
    },
};

export default audioUtils;
